import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { RecipeCloudinaryImage, RecipeImageGenerationRequest } from '../../shared/models/recipe-image.model';

@Injectable({ providedIn: 'root' })
export class ImageService {
  private static readonly BASE_URL = `${environment.apiUrl}/image`;

  constructor(private http: HttpClient) {}

  uploadImage(formData: FormData): Observable<RecipeCloudinaryImage> {
    return this.http.post<RecipeCloudinaryImage>(`${ImageService.BASE_URL}/upload`, formData);
  }

  generateRecipeImage(context: RecipeImageGenerationRequest): Observable<RecipeCloudinaryImage> {
    return this.http.post<RecipeCloudinaryImage>(`${ImageService.BASE_URL}/generate`, context);
  }

  deleteImage(publicId: string): Observable<{ result: string }> {
    const encoded = btoa(publicId);
    return this.http.delete<{ result: string }>(`${ImageService.BASE_URL}/delete/${encoded}`);
  }
}
